module.exports = __webpack_public_path__ + "img/signal_wifi_statusbar_2_bar_26x24px.0e87ac11.svg";